import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {apis} from '../../../services/alm';
import CoursePlayer from '../../common/player/CoursePlayer';
import {useSearchParams} from 'react-router-dom';
import {ActionType, AppcuesConstant, constants, FileNotation, LiveMeetingInt, Minutes, podCastTags, Tag} from '../../../assets/constants/constants';
import {AppContext} from '../../../context/AppProvider';
import useSubscription from '../../../hooks/useSubscription';
import {CourseDetailParmsType} from '../../../interface';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import {bookMarkData, compareByWeek, covertDateUtcToIST, defaultImage, PodcastTags} from '../../../lib/utils';
import {ShareAndBookMark} from '../../common/ShareAndBookMark';
import {DetailTabSection} from '../course-detail/tab-section/DetailTabSection';
import LibraryRelatedContent from './LibraryRelatedContent';
import LibraryWeekDetail from './LibraryWeekDetail';
import PlayButton from '../../common/PlayButton';
import useGetEnrolled from '../../../hooks/useGetEnrolled';
import { Button } from 'alm-react-components';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import useGaEventTracking from '../../../hooks/UseGaEventTracking.tsx';
import { analytics_category, analytics_event, analytics_label, appcues_event } from '../../../assets/constants/staticContentConstants.ts';
import { completLiveClassMeeting } from '../../../services/user.ts';
import { putAppCuesData } from '../../../lib/appcues.ts';

const LibraryCourseDetail = ({catalogDataByid,setIsBookmarkClicked}:any) => {
  const {courseId} = useParams<CourseDetailParmsType>();
  const [courseData, setCourseData] = useState<any>(null);
  const {state,dispatch} = useContext(AppContext);
  const [playCourse, setPlayCourse] = useState(false);
  const [isUserEnrolled, setUserEnrolled] = useState(false);
  const [bookmarked, setBookmarked] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {t}=useTranslation()
  const { tagsData } = useGetEnrolled()
  const [query]=useSearchParams()
  const catId=query.get('catId')
  const courseType: any = decodeURIComponent(location?.state?.courseType);
  const from: any = location?.state?.from;
  const [libraryCourseData, setlibraryCourseData] = useState<any>();
  const notification: any = query.get('notification');
  const relatedId: any = location?.state?.relatedId;
  const filterTag: any = location?.state?.filterTag;
  const filterationTag: any = location?.state?.filterationTag;
  const [courseList, setCourseList] = useState<any>(null);
  const [relatedContentData, setRelatedContentData] = useState<any>([]);
  const {callSubscription} = useSubscription();
  const [lessonTranscriptLocation, setLessonTranscriptLocation] = useState<string>('');
  const [isExternalUrl, setIsInternalUrl] = useState<any>({ flag: false, urlLink: "" });
  const [bookMarkTag, setbookMarkTag] = useState<string>('');
  const [, setEexercise] = useState(false);
  const [
    courseRelationshipsInstancesLoResourcesId,
    setCourseRelationshipsInstancesLoResourcesId,
  ] = useState<string>("");
  const [
    liveMeetingDetail,
    setLiveMeetingDetail,
  ] = useState<any>("");
  useEffect(() => {
    if(state.user){
      if(!state.user?.corporateAccountId)
        callSubscription("valid");
    }
  }, [state.user]);
  const gaEventTracker = useGaEventTracking();

  const fetchData = async () => {
    dispatch({ type: ActionType.SET_LOADING, payload: true });
    const response: any = await apis.getProgramList(courseId);
    if (response?.data?.relationships?.enrollment) {
      setUserEnrolled(true);
    }
    const tags = response?.data?.attributes?.tags
    if(tags?.includes(Tag.liveclass)){
      const courseRelationshipsInstances = response?.included?.find(
        (ele: any) => {
          return ele.id === response?.data?.relationships?.instances?.data[0]?.id;
        }
      );
      ///Get recording lession/module id 
      const courseRelationshipsInstancesLoResourcesId =
      response?.included?.find((ele: any) => {
          return (
            ele.id ===
            courseRelationshipsInstances?.relationships?.loResources?.data[1]
              ?.id
          );
        });

      ///Set recording lession/module id 
      if (courseRelationshipsInstancesLoResourcesId) {
        setCourseRelationshipsInstancesLoResourcesId(
          courseRelationshipsInstancesLoResourcesId.id
        );
      }
      ///Extract live meting detail 
      ///Get live lession/module id 
      const courseRelationshipsInstancesLoResourcesIdLive =
      response?.included?.find((ele: any) => {
          return (
            ele.id ===
            courseRelationshipsInstances?.relationships?.loResources?.data[0]
              ?.id
          );
        });
      ///Get live lession/module detail 
      const courseRelationshipsInstancesLoResourcesIdLiveMeetingModule=
      response?.included?.find((ele: any) => {
          return (
            ele.id ===
            courseRelationshipsInstancesLoResourcesIdLive?.relationships?.resources?.data[0]
              ?.id
          );
        });
      if(courseRelationshipsInstancesLoResourcesIdLiveMeetingModule?.id){
        setLiveMeetingDetail(courseRelationshipsInstancesLoResourcesIdLiveMeetingModule?.attributes)
      }
      setbookMarkTag(Tag.liveclass)
    }else  {
      if (courseType === constants.MY_BOOKMARK) {
        const actualTag: any = bookMarkData?.find((item: any) => tags?.includes(item))
        setbookMarkTag(actualTag)
      }
    }
    setEexercise(tags?.includes(Tag.exercise))
    
    if (response?.data?.attributes?.loFormat === constants.ACTIVITY) {
      const enrollemntId = response?.data?.relationships?.enrollment?.data?.id
      const resourceId = response?.included?.filter((res: any) => res?.id === enrollemntId)[0]?.relationships?.loInstance?.data?.id
      let finalResourceId: any = ""
      if (resourceId) {
        const id = response?.included?.filter((res: any) => res?.id === resourceId)[0]?.relationships?.loResources?.data[0]?.id
        finalResourceId = id + '_resource'
      }
      if (finalResourceId) {
        const resourceDataLink = response?.included?.filter((res: any) => res?.id === finalResourceId)[0]?.attributes?.location
        setIsInternalUrl({ flag: true, urlLink: resourceDataLink })
      }
    } else {
      setIsInternalUrl({ flag: false, urlLink: "" })
    }
    dispatch({ type: ActionType.SET_LOADING, payload: false });
    if (response?.data?.relationships?.enrollment) {
      setUserEnrolled(true);
    }
    setLessonTranscriptLocation('');
    response?.data.relationships?.supplementaryResources?.data.forEach((val: any) => {
      response?.included?.find((ele: any) => {
        if (ele.id === val.id) {
          const file = ele.attributes.name;
          if (file.endsWith(FileNotation.transcript)) {
            setLessonTranscriptLocation(ele?.attributes?.location);
          }
        }
      });
    });
    setCourseData(response);
    setBookmarked(response?.data?.attributes?.isBookmarked);
  };
  
  const getCourseType =()=>{
    const completionDeadline_ = liveMeetingDetail.completionDeadline; //'2024-07-15T10:30:00.000Z';
    const endTime = covertDateUtcToIST(completionDeadline_, state?.user?.timeZoneCode);
        if(courseRelationshipsInstancesLoResourcesId)
          return constants.recording;
        else if(moment(moment().format(moment.HTML5_FMT.DATETIME_LOCAL)).isAfter(endTime))
          return constants.meetingAlreadyCompleted;
        else
          return constants.MEETING;
  }


  useEffect(() => {
    if (tagsData?.length && filterationTag && filterationTag !== constants.MY_BOOKMARK && filterationTag !== constants.RECOMMENDED) {
      if (filterationTag === constants.PODCAST) {
        let data = state?.libraryData[courseType]?.sort((a: any, b: any) => b?.attributes?.localizedMetadata[0]?.name.localeCompare(a?.attributes?.localizedMetadata[0]?.name, 'es', { sensitivity: 'base' }))?.filter((item: any) => {
          return tagsData.some((res: any) => {
            return (
              item?.attributes?.tags?.includes(res?.attributes?.localizedMetadata[0]?.name) ||
              item?.attributes?.tags?.includes(podCastTags.innerSTancePodcasts) ||
              item?.attributes?.tags?.includes(podCastTags.newPodcasts) ||
              item?.attributes?.tags?.includes(podCastTags.specialPodcasts) ||
              item?.attributes?.tags?.includes(podCastTags.straightLinePodcasts) ||
              !item?.attributes?.tags
            );
          });
        });
        setlibraryCourseData(data);
      } else {
        let data = state?.libraryData[courseType]?.filter((item: any) => {
          return tagsData.some((res: any) => {
            return (
              item?.attributes?.tags?.includes(res?.attributes?.localizedMetadata[0]?.name) ||
              item?.attributes?.tags?.includes(filterationTag) ||
              !item?.attributes?.tags
            );
          });
        });
        setlibraryCourseData(data);
      }

    } else if ((!tagsData.length || tagsData?.length) && filterTag !== constants.others && filterTag !== constants.MY_BOOKMARK && filterTag !== undefined) {
      const podcastKeyValues = Object.entries(podCastTags)
      const finalvalue:any = podcastKeyValues?.find(([_,value])=>value===filterTag)
      if(finalvalue && finalvalue[1]=== filterTag){

        let data = state?.libraryData[courseType]?.sort((a: any, b: any) => b?.attributes?.localizedMetadata[0]?.name.localeCompare(a?.attributes?.localizedMetadata[0]?.name, 'es', { sensitivity: 'base' }))?.filter((item: any) => {
          return item?.attributes?.tags?.includes(filterTag)
        })
        setlibraryCourseData(data)
      }
      else {

        let data = state?.libraryData[courseType].sort(compareByWeek)?.filter((item: any) => {
          return item?.attributes?.tags?.includes(filterTag)
        })
        setlibraryCourseData(data)
      }
      let data = state?.libraryData[courseType]?.filter((item: any) => {
        return item?.attributes?.tags?.includes(filterTag)
      })
      setlibraryCourseData(data)
    }
    else if (tagsData?.length && filterTag == constants.others) {
      let data = state?.libraryData[courseType]?.filter((item: any) => {
        return !item?.attributes?.tags
      })

      setlibraryCourseData(data)
    }
    else if (!tagsData?.length && filterationTag && filterationTag !== constants.MY_BOOKMARK && filterationTag !== constants.RECOMMENDED) {
      if (filterationTag === constants.PODCAST) {
          let data = state?.libraryData[courseType]?.sort((a: any, b: any) => b?.attributes?.localizedMetadata[0]?.name.localeCompare(a?.attributes?.localizedMetadata[0]?.name, 'es', { sensitivity: 'base' }))?.filter((item: any) => {
            
              return (
                item?.attributes?.tags?.includes(item?.attributes?.localizedMetadata[0]?.name) ||
                item?.attributes?.tags?.includes(podCastTags.innerSTancePodcasts) ||
                item?.attributes?.tags?.includes(podCastTags.newPodcasts) ||
                item?.attributes?.tags?.includes(podCastTags.specialPodcasts) ||
                item?.attributes?.tags?.includes(podCastTags.straightLinePodcasts) ||
                !item?.attributes?.tags
              )
          });
          setlibraryCourseData(data);
        }else{
          let data = state?.libraryData[courseType]?.filter((item: any) => {
            return item?.attributes?.tags?.includes(filterationTag) ||
              !item?.attributes?.tags
          })
          setlibraryCourseData(data)
        }
    }
    else if (!tagsData?.length && filterTag && !PodcastTags.includes(filterTag)) {
      let data = state?.libraryData[courseType]?.filter((item: any) => {
        return item?.attributes?.tags?.includes(filterTag)
      })
      setlibraryCourseData(data)
    } else if (courseType == constants.MY_BOOKMARK && filterationTag == constants.MY_BOOKMARK) {

      const test =async()=>{
        const result = await apis.myBookmarks();
        
      setlibraryCourseData(result?.data)
      }
      test()
     
    }
    else if (filterationTag === constants.MY_BOOKMARK) {

      let data = state?.libraryData[courseType]
      setlibraryCourseData(data)
    }
    else if (filterationTag === constants.RECOMMENDED) {

      let data = state?.libraryData[courseType]
      setlibraryCourseData(data)
    }
    else {

      setlibraryCourseData([])
    }
  }, [state.libraryData, tagsData])
  useEffect(() => {
    fetchData();
  }, [courseId, bookmarked, relatedId, isUserEnrolled]);

  useEffect(() => {
    const fetchRelatedContent = async () => {
      const relatedContent = await apis.getRelatedContent(relatedId ? relatedId : courseId);
      const list = relatedContent.data?.map((course: any) => {
        return {
          id: course.id,
          bannerUrl: course?.attributes?.bannerUrl,
          name: getLocalizedContent(course?.attributes?.localizedMetadata)?.name,
          isBookmarked: course?.attributes?.isBookmarked,
          imageUrl:course?.attributes?.imageUrl
        };
      });
      setRelatedContentData(list);
    };
    if (courseType === constants.relatedContent) {
      fetchRelatedContent();
    }else{
      setRelatedContentData([])
    }
  }, [courseType,libraryCourseData,courseId]);
  useEffect(() => {
    if (libraryCourseData) {
      const list = libraryCourseData?.map((course: any) => {
        return {
          id: course.id,
          bannerUrl: course?.attributes?.bannerUrl,
          imageUrl: course?.attributes?.imageUrl,
          name: getLocalizedContent(course?.attributes?.localizedMetadata)?.name,
          isBookmarked: course?.attributes?.isBookmarked,
        };
      });
      setCourseList(list);
    }
  }, [libraryCourseData,courseType]);
  const instanceID = courseData?.data?.relationships?.instances?.data[0].id;
  const playBtnAction=()=>{
    //check if the live lession has meeting and has no recording
    const liveClassdateStart_ = liveMeetingDetail.dateStart; //'2024-07-15T9:22:00.000Z';
    const completionDeadline_ = liveMeetingDetail.completionDeadline; //'2024-07-15T10:30:00.000Z';

    const startTime = covertDateUtcToIST(liveClassdateStart_, state?.user?.timeZoneCode);
    const endTime = covertDateUtcToIST(completionDeadline_, state?.user?.timeZoneCode);
    const startBeforeFifteenMint = moment(startTime).subtract(LiveMeetingInt, Minutes)

    if(!courseRelationshipsInstancesLoResourcesId ){
      if(moment().isBetween(startBeforeFifteenMint,endTime))
        {
        window.open(liveMeetingDetail?.location)
      }
      else if(moment(moment().format(moment.HTML5_FMT.DATETIME_LOCAL)).isAfter(endTime)){
        // dispatch({type:ActionType.ALERT_BOX,payload:{
        //   visible:true,
        //   message:t('Common.meetingAlreadyCompleted')
        // }})
      }
      else{
        dispatch({type:ActionType.ALERT_BOX,payload:{
          visible:true,
          message:t('Common.meetingNotStarted')
        }})
      }
    }else{
      setPlayCourse(true);
    }
    setPlayCourse(true)
  }
  const playLibraryContent = async (courseType:string) => {
    const res = await apis.userEnroll(courseId, instanceID);
    if(!bookMarkData.includes(courseType)){
      if (res?.data?.type === 'learningObjectInstanceEnrollment' ) {
        setUserEnrolled(true);
        window.open(liveMeetingDetail?.location)
      }
    }
    
    if(courseType === constants.MEETING){
      completLiveClassMeeting(courseId);
      return false
    }
      
    if (isExternalUrl?.flag) {
      putAppCuesData({
        event_Name:appcues_event.lessonStarted,
        eventName:`${appcues_event.lessonStarted}_${courseType}_${courseId}_${content.name}`,
        userId: state.user?.email || "",
        program_id: AppcuesConstant.DataFromLibrary,
        lesson_id: courseId,
        lesson_name: content?.name,
        lesson_type:courseType !== null ? courseType: AppcuesConstant.otherContent,})
        putAppCuesData({
          event_Name:appcues_event.lessonCompleted,
          eventName:`${appcues_event.lessonCompleted}_${courseType}_${courseId}_${content.name}`,
          userId: state.user?.email || "",
          program_id: AppcuesConstant.DataFromLibrary,
          lesson_id: courseId,
          lesson_name: content?.name,
          lesson_type:courseType !== null ? courseType : AppcuesConstant.otherContent,})
      window.open(isExternalUrl?.urlLink)
      return false
    } else if(bookMarkTag===Tag.liveclass){
      playBtnAction()
    }
    const items = {
      value: null,
      currency:null,
      transaction_id: null,
      items: [{}],
      userId:state.user?.userId,
      course_id:courseId,
      course_name:content?.name,
      timestamp:new Date()
  };
gaEventTracker(
  analytics_event.WatchContent(courseType),
  analytics_category.buttonClickViewContent,
  analytics_label.WatchContentLabel(courseType),
  items
);
      putAppCuesData({
        event_Name:appcues_event.lessonStarted,
        eventName:`${appcues_event.lessonStarted}_${courseType}_${content.name}`,
        userId: state.user?.email || "",
        program_id: AppcuesConstant.DataFromLibrary,
        lesson_id: courseId,
        lesson_name: content?.name,
        lesson_type:courseType !== null ? courseType: AppcuesConstant.otherContent,})
        putAppCuesData({
          event_Name:appcues_event.lessonCompleted,
          eventName:`${appcues_event.lessonCompleted}_${courseType}_${content.name}`,
          userId: state.user?.email || "",
          program_id: AppcuesConstant.DataFromLibrary,
          lesson_id: courseId,
          lesson_name: content?.name,
          lesson_type:courseType !== null ? courseType: AppcuesConstant.otherContent,})
    setPlayCourse(true)
  }
  const courseUpdate = async (id: any) => {
    setPlayCourse(false);
    if (filterTag || courseType===constants.NEW_VIDEO) {
      navigate(
        `/home/library/library-course/${id}?catId=${catId}`, { state: { courseType: encodeURIComponent(courseType), filterTag: filterTag, from: from } });
    }
    else if (filterationTag === constants.NEW_VIDEO) {
      navigate(`/home/library/library-course/${id}`, { state: { courseType: encodeURIComponent(courseType), filterationTag: constants.NEW_VIDEO, from: from } });
    }
    else if (relatedId) {
      navigate(`/home/library/library-course/${id}`, {
        state: {
          courseType: "relatedContent",
          relatedId: relatedId,
          from:from
        }
      });
    }
   
    else {
      navigate(`/home/library/library-course/${id}`, { state: { courseType: encodeURIComponent(courseType), filterationTag: courseType, from: from } });
    }
  };
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }, []);
  const onPressBookMark = (flag: boolean) => {
    if (courseId) {

      const updatedCourseList = courseList?.map((val: any) => val.id == courseId ?
        { ...val, isBookmarked: flag } : val);
      setCourseList(updatedCourseList)
      catalogDataByid()
      setIsBookmarkClicked((prev:any)=>!prev)
    }
    if (relatedContentData) {
      const updatedRelatedContent = relatedContentData?.map((val: any) => val.id == courseId ?
        { ...val, isBookmarked: flag } : val);
      setRelatedContentData(updatedRelatedContent)
    }
  };
  const content = getLocalizedContent(courseData?.data?.attributes?.localizedMetadata);
  return (
        <>
          <section className="h-fit">
            <>
            <div className="px-6 pt-6 lg:px-8 xl:pr-32 xl:pl-32 md:pt-14 w-[100%] md:px-8">
              <div className="flex justify-between items-center relative">
                <Button
                  onClick={() =>  {
                    if(courseType===constants.PODCAST && catId){
                      navigate(`/${courseType.toLowerCase()+'s'}/${catId}`)
                    }else if(courseType===constants.DOCUMENTS_AND_BULLETINS && catId){
                      navigate(`/${constants.BULLETINS}/${catId}`)
                    }else if(catId){
                      navigate(`/${courseType}/${catId}`)
                    }else if(filterTag===undefined && filterationTag===undefined){
                      navigate(-1)
                    }
                    else if(filterTag===undefined && filterationTag===undefined && relatedId && from){
                       navigate(from)
                    }else{
                      navigate(`${from}`)
                    }
                  }
                  }
                  variant="default"
                  className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0"
                >
                  <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
                </Button>
              </div>
            </div>
          
              <div className="gap-6 xl:gap-6 md:grid md:grid-cols-3 py-5 mx-auto md:py-8 px-4 xl:px-32 md:px-8 lg:px-8">
                {courseId && (
                  <div className="col-span-2 pb-4">
                    <div className={`mb-6 max-h-[568px] aspect-[6/3] md:aspect-[6/3] xl:aspect-[6/3] 2xl:aspect-[6/3] relative`}>
                      {courseId && playCourse ? (
                        <CoursePlayer
                          cid={courseId}
                          mid={courseRelationshipsInstancesLoResourcesId?courseRelationshipsInstancesLoResourcesId:""}
                          goBackUrl={location.pathname}
                          fullScreen={false}
                          playVideo={setPlayCourse}
                          courseName={courseData?.data?.attributes?.localizedMetadata[0]?.name}
                          courseType={bookMarkTag==="liveclass" ? getCourseType():bookMarkTag?bookMarkTag : courseType}
                        />
                      ) : (
                        <>
                          {courseData?.data?.attributes?.bannerUrl ? (
                            <img
                              src={courseData?.data?.attributes?.bannerUrl}
                              alt=""
                              className="object-cover w-full max-h-[568px] rounded-2xl"
                            />
                          ) : (
                            <img
                              src={defaultImage()}
                              alt=""
                              className="object-cover w-full max-h-[568px] rounded-2xl"
                            />
                          )}
                          <div>
                          <PlayButton courseType={bookMarkTag==="liveclass" ? getCourseType():bookMarkTag?bookMarkTag : courseType} handleVideo={playLibraryContent} />
                          </div>
                        </> 
                      )}
                    </div>
                    <div className="gap-4 xl:gap-8 md:grid md:grid-cols-3 max-w-screen-xl">
                      <div className="col-span-2 pb-4 flex flex-col">
                        <h2 className="lg:text-xl xl:text-2xl 2xl:text-3xl font-opensansSemiBold font-opensansSemiBold text-left">
                          {content?.name}
                        </h2>
                        <p className="mt-3 text-base font-opensansLight tracking-wider">
                          {content?.description}
                        </p>
                      </div>
                      {courseList && courseId && !relatedId && <ShareAndBookMark
                    courseId={courseId}
                    isBookmarked={courseList?.filter((val: any) => val.id == courseId)[0]?.isBookmarked}
                    setBookmarked={onPressBookMark}
                    courseName={courseList?.filter((val: any) => val.id == courseId)[0]?.name}
                  />}
                  { relatedContentData && relatedId && <ShareAndBookMark
                    courseId={courseId}
                    isBookmarked={relatedContentData?.filter((val: any) => val.id == courseId)[0]?.isBookmarked}
                    setBookmarked={onPressBookMark}
                    courseName={courseList?.filter((val: any) => val.id == courseId)[0]?.name}
                  />}
                    </div>
                  </div>
                )}
                <div className="mt-4 md:mt-0">
                  <div className="gap-5 grid dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-8 dark:focus:ring-[#3b5998]/55 me-2 mb-2 w-full">
                    <div className="col-span-2 pe-4 flex flex-col text-left">
                      <h2 className="lg:text-xl xl:text-2xl font-barlowRegular">{content?.name}</h2>
                    </div>
                  </div>
                  <LibraryWeekDetail
                    courseUpdate={courseUpdate}
                    courseList={relatedContentData.length ? relatedContentData : courseList}
                    courseId={relatedId ? relatedId : courseId}
                    courseType={courseType}
                    notification={notification}
                  />
                </div>
              </div>
            </>
          </section>
          {courseId && (
            <DetailTabSection
              mainLearningProgramId={'library'}
              learningProgramId={''}
              courseResponse={courseData?.data}
              courseId={courseId}
              type={courseType}
              selectedProgram={''}
              transcriptLocation={lessonTranscriptLocation}
              isUserEnrolled={isUserEnrolled}
              currentLessionDetail={courseData}
            />
          )}
          <LibraryRelatedContent courseId={courseId} from={from} />
        </>
  );
};

export default LibraryCourseDetail;
